import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Button, Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useRef, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import DivisionCmp from "../../components/cards/DivisionCmp";
import ImagePreviewComponent from "../../components/cards/imagePreviewCmp";
import ModalPrint from "../../components/modals/ModalPrint";
import {
  GetCartableActionsResponse,
  GetCoreInformationResponse,
  GetSupplierInformationResponse,
} from "../../models/cartable.model";
import { ApiResultModel } from "../../models/common.model";
import { GetInstallmentTableRequest } from "../../models/loan.model";
import {
  GetAppInformation,
  GetCartableActions,
  GetCoreInformation,
  GetSupplierInformation,
} from "../../services/cartable.service";
import { exportInstallmentCheques } from "../../services/loan.service";
import ActionModal from "./actionCopmonets.tsx/actionModal";
import InstallmentCheck from "./installmentCheck";
import CancellationReasons from "./tabs/cancelReason";
import FactorInfo from "./tabs/factorInfo";
import GuarantorInfo from "./tabs/guarantorInfo";
import GuarantorPlaceInfo from "./tabs/guarantorPlaceInfo";
import IncomeInfo from "./tabs/incomeInfo";
import PdfComponent from "./tabs/pdfComponent";
import PlaceInfo from "./tabs/placeInfo";
import SelectedLoan from "./tabs/selectedLoan";
import SellerDocument from "./tabs/sellerDocument";
import UserInfo from "./tabs/userInfo";
import VehicleDocuments from "./tabs/vehicleDocuments";
import VehicleExpert from "./tabs/vehicleExpert";
import WorkflowInfoPrint from "./tabs/workflowInfoPrint";

export default function HeaderInfo(props: any) {
  const [installmentCheck, setInstallmentCheck] = React.useState<any>();
  const [showActionBtns, setShowActionBtns] = useState(true);
  const [isActionModalBtnDisable, setActionModalBtnDisable] = useState(false);

  let nationalIdEnum = [
    {
      documentType: "NationalCardFront",
      documentTypeTitle: " روی کارت ملی",
    },
    {
      documentType: "NationalCardBack",
      documentTypeTitle: " پشت کارت ملی",
    },
  ];

  let idEnum = [
    {
      documentType: "IdentityDocument_Page1",
      documentTypeTitle: " صفحه اول شناسنامه ",
    },
    {
      documentType: "IdentityDocument_Page2",
      documentTypeTitle: "صفحه دوم شناسنامه ",
    },
    {
      documentType: "IdentityDocument_PageDescription",
      documentTypeTitle: "صفحه توضیحات شناسنامه ",
    },
  ];
  let findednationalId: any;
  let findedId: any;
  if (props.printedData.identityDocuments) {
    findednationalId = props.printedData.identityDocuments.filter(
      (v: any) =>
        nationalIdEnum?.findIndex(
          (x: { documentType: String }) => x.documentType === v.documentType
        ) >= 0
    );
    findedId = props.printedData.identityDocuments.filter(
      (v: any) =>
        idEnum?.findIndex(
          (x: { documentType: String }) => x.documentType === v.documentType
        ) >= 0
    );
  }

  const installmentCheques = props.printedData.installmentCheques?.filter(
    (item: any) => item.file != null && item.file != undefined
  ).length;
  const printedArray = [
    {
      id: 0,
      key: "Identity",
      title: " اطلاعات هویتی ",
      showDocuments: false,
      showComponent: true,
      showItemInModal: true,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      justComponent:
        findednationalId?.length > 0 || findedId?.length > 0 ? false : true,
      documents:
        props.printedData.identityDocuments != undefined &&
        props.printedData.identityDocuments != null ? (
          <>
            {findednationalId?.length > 0 ? (
              <DivisionCmp
                title={"تصاویر کارت ملی"}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    {findednationalId?.map((item: any) => (
                      <Grid item xs={12} className='classCenter'>
                        {/* <Grid item xs={12} style={{ marginTop: "1.5vh", display: "flex !important" }} >
                          <p style={{ border: "2px solid gray", alignSelf: "center", width: "fit-content" }}>test</p>
                        </Grid> */}
                        <div
                          style={{
                            width: "auto",
                            height: "auto",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              overflow: "hidden",
                            }}
                            src={item.fileUrl}
                            alt=''
                          />
                        </div>
                        {/* <LoadDocumentCmp data={item} title={false} /> */}
                      </Grid>
                    ))}
                  </Grid>
                }
              ></DivisionCmp>
            ) : (
              ""
            )}
            {findedId?.length > 0 ? (
              <DivisionCmp
                title={"تصاویر شناسنامه"}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    {findedId?.map((item: any) => (
                      <Grid item xs={12} className='classCenter'>
                        {/* <Grid item xs={12} style={{ marginTop: "1.5vh", display: "flex !important" }} >
                          <p style={{ border: "2px solid gray", alignSelf: "center", width: "fit-content" }}>test</p>
                        </Grid> */}
                        <div
                          style={{
                            width: "auto",
                            height: "auto",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              overflow: "hidden",
                            }}
                            src={item.fileUrl}
                            alt=''
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                }
              ></DivisionCmp>
            ) : (
              ""
            )}
          </>
        ) : (
          <></>
        ),
      child:
        props.printedData.loanRequestInfo != undefined &&
        props.printedData.loanRequestInfo != null ? (
          <UserInfo data={props.printedData.loanRequestInfo} />
        ) : (
          <></>
        ),
    },
    {
      id: 1,
      key: "selectedLoan",
      title: "مشخصات طرح انتخاب شده",
      showDocuments: false,
      showComponent: true,
      showItemInModal: true,
      justDocuments: false,
      justComponent: true,
      showDocumentsBottomOfPage: true,
      child:
        props.printedData.loanRequestInfo != undefined &&
        props.printedData.loanRequestInfo != null ? (
          <SelectedLoan
            value={props.printedData.loanRequestInfo}
            withoutDoc={false}
            title='مشخصات طرح انتخاب شده'
          />
        ) : (
          <></>
        ),
    },
    {
      id: 2,
      key: "Residential",
      title: " اطلاعات سکونتی ",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      justComponent:
        props.printedData.address != undefined &&
        props.printedData.address != null &&
        props.printedData.address?.documentUrls != undefined &&
        props.printedData.address?.documentUrls != null &&
        props.printedData.address?.documentUrls.length > 0
          ? false
          : true,
      showItemInModal:
        props.printedData.address != undefined &&
        props.printedData.address != null
          ? true
          : false,
      documents:
        props.printedData.address != undefined &&
        props.printedData.address != null &&
        props.printedData.address?.documentUrls != undefined &&
        props.printedData.address?.documentUrls != null ? (
          <DivisionCmp
            title={"تصاویر اطلاعات سکونتی"}
            child={props.printedData.address?.documentUrls?.map((img: any) => (
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.address?.documentUrls?.map((item: any) =>
                  item.fileType == "Image" ? (
                    <Grid item xs={12} className='classCenter'>
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                          }}
                          src={item.fileUrl}
                          alt=''
                        />
                      </div>
                    </Grid>
                  ) : (
                    <PdfComponent fileDocument={item.fileUrl} />
                  )
                )}
              </Grid>
            ))}
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.address != undefined &&
        props.printedData.address != null ? (
          <PlaceInfo
            data={props.printedData.address}
            title={" اطلاعات سکونتی"}
            withoutDoc={false}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 3,
      key: "Incomes",
      title: " اطلاعات درآمدی ",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      justComponent:
        props.printedData.incomes != undefined &&
        props.printedData.incomes != null &&
        props.printedData.incomes.length > 0
          ? false
          : true,
      showItemInModal:
        props.printedData.incomes != undefined &&
        props.printedData.incomes != null &&
        props.printedData.incomes.length > 0
          ? true
          : false,
      documents:
        props.printedData.incomes != undefined &&
        props.printedData.incomes != null &&
        props.printedData.incomes.length > 0 ? (
          props.printedData.incomes?.map((item: any) => (
            <DivisionCmp
              title={" تصاویر درآمدی " + item.incomeTypeTitle}
              child={
                <Grid
                  container
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                >
                  {item.filesUrls?.map((doc: any) =>
                    doc.fileType == "Image" ? (
                      <Grid item xs={12} className='classCenter'>
                        <div
                          style={{
                            width: "auto",
                            height: "auto",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              overflow: "hidden",
                            }}
                            src={doc.fileUrl}
                            alt=''
                          />
                        </div>
                      </Grid>
                    ) : (
                      <PdfComponent fileDocument={doc.fileUrl} />
                    )
                  )}
                </Grid>
              }
            ></DivisionCmp>
          ))
        ) : (
          <></>
        ),
      child:
        props.printedData.incomes != undefined &&
        props.printedData.incomes != null ? (
          <IncomeInfo
            data={props.printedData.incomes}
            title={" اطلاعات درآمدی (آزاد)"}
            withoutDoc={false}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 4,
      key: "Guarantee",
      title: " اطلاعات ضمانتی",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      justComponent:
        props.printedData.guarenteeCheque?.file?.fileUrl != undefined &&
        props.printedData.guarenteeCheque?.file?.fileUrl != null
          ? false
          : true,
      showItemInModal:
        props.printedData.guarenteeCheque != undefined &&
        props.printedData.guarenteeCheque != null
          ? true
          : false,
      documents:
        props.printedData.guarenteeCheque != undefined &&
        props.printedData.guarenteeCheque != null ? (
          <DivisionCmp
            title={"تصاویر چک ضمانت خریدار"}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.guarenteeCheque?.file?.fileType ==
                "Image" ? (
                  <Grid item xs={12} className='classCenter'>
                    <ImagePreviewComponent
                      breakPage={false}
                      file={props.printedData.guarenteeCheque?.file}
                      rearFile={props.printedData.guarenteeCheque?.rearFile}
                    />
                  </Grid>
                ) : (
                  <PdfComponent
                    fileDocument={
                      props.printedData.guarenteeCheque?.file?.fileUrl
                    }
                  />
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.guarenteeCheque != undefined &&
        props.printedData.guarenteeCheque != null ? (
          <GuarantorInfo
            data={props.printedData.guarenteeCheque}
            withoutDoc={false}
          />
        ) : (
          <></>
        ),
    },
    // {
    //   id: 4,
    //   key: "Installment",
    //   title: " اطلاعات اقساط",
    //   showDocuments: false,
    //   showComponent: false,
    //   child: <InstallmentInfo data={props.printedData.installmentInfo}  />,
    // },

    {
      id: 5,
      key: "Contract",
      title: " اطلاعات قرارداد",
      showDocuments: false,
      showComponent: false,
      justDocuments: true,
      justComponent: false,
      showDocumentsBottomOfPage: true,
      showItemInModal:
        props.printedData.contract != undefined &&
        props.printedData.contract != null &&
        props.printedData.contract.length > 0
          ? true
          : false,
      documents:
        props.printedData.contract != undefined &&
        props.printedData.contract != null ? (
          <DivisionCmp
            title={" تصاویر قرارداد "}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.contract?.map((item: any) => (
                  <Grid item xs={12} className='classCenter'>
                    <PdfComponent fileDocument={item.fileUrl} />
                  </Grid>
                ))}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          // <DivisionCmp title={" اطلاعات قرارداد"} child={<PdfComponent fileDocument={props.printedData?.contract[0].fileUrl} />}>
          // </DivisionCmp>

          <></>
        ),
      child: <></>,
    },
    {
      id: 6,
      key: "Factor",
      title: " فاکتور فروش و تحویل کالا  ",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      justComponent:
        props.printedData.factor?.deliveryReceiptFile?.fileUrl != undefined &&
        props.printedData.factor?.deliveryReceiptFile?.fileUrl != null
          ? false
          : true,
      showItemInModal:
        props.printedData.factor != undefined &&
        props.printedData.factor != null
          ? true
          : false,
      documents:
        props.printedData.factor != undefined &&
        props.printedData.factor != null ? (
          <DivisionCmp
            title={"تصاویر فاکتور فروش و تحویل کالا "}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.factor?.factorFile?.fileType == "Image" ? (
                  <Grid item xs={12} className='classCenter'>
                    <div
                      style={{
                        width: "auto",
                        height: "auto",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          overflow: "hidden",
                        }}
                        src={props.printedData.factor?.factorFile?.fileUrl}
                        alt=''
                      />
                    </div>
                  </Grid>
                ) : (
                  <PdfComponent
                    fileDocument={props.printedData.factor?.factorFile?.fileUrl}
                  />
                )}
                {props.printedData.factor?.deliveryReceiptFile?.fileType ==
                "Image" ? (
                  <Grid item xs={12} className='classCenter'>
                    <div
                      style={{
                        width: "auto",
                        height: "auto",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          overflow: "hidden",
                        }}
                        src={
                          props.printedData.factor?.deliveryReceiptFile?.fileUrl
                        }
                        alt=''
                      />
                    </div>
                  </Grid>
                ) : (
                  <PdfComponent
                    fileDocument={
                      props.printedData.factor?.deliveryReceiptFile?.fileUrl
                    }
                  />
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.factor != undefined &&
        props.printedData.factor != null ? (
          <FactorInfo
            data={props.printedData.factor}
            withoutDoc={false}
            showInPrintMode={true}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 7,
      key: "Other",
      title: " اطلاعات تکمیلی",
      showDocuments: false,
      showComponent: false,
      justDocuments: true,
      showDocumentsBottomOfPage: true,
      justComponent:
        props.printedData.otherDocuments != undefined &&
        props.printedData.otherDocuments != null &&
        props.printedData.otherDocuments.length > 0
          ? false
          : true,
      showItemInModal:
        props.printedData.otherDocuments != undefined &&
        props.printedData.otherDocuments != null &&
        props.printedData.otherDocuments.length > 0
          ? true
          : false,
      documents:
        props.printedData.otherDocuments != undefined &&
        props.printedData.otherDocuments != null ? (
          <DivisionCmp
            title={" تصاویر اطلاعات تکمیلی "}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.otherDocuments?.map((item: any) =>
                  item.fileType == "Image" ? (
                    <Grid item xs={12} className='classCenter'>
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                          }}
                          src={item.fileUrl}
                          alt=''
                        />
                      </div>
                    </Grid>
                  ) : (
                    <PdfComponent fileDocument={item.fileUrl} />
                  )
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child: <></>,
    },
    {
      id: 8,
      key: "CartableHistory",
      title: " اطلاعات گردش کار",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      justComponent: true,
      showDocumentsBottomOfPage: true,
      showItemInModal:
        props.printedData.cartableHistory != undefined &&
        props.printedData.cartableHistory != null &&
        props.printedData.cartableHistory.length > 0
          ? true
          : false,
      documents: <></>,
      child:
        props.printedData.cartableHistory != undefined &&
        props.printedData.cartableHistory != null ? (
          <DivisionCmp
            child={
              <WorkflowInfoPrint data={props.printedData.cartableHistory} />
            }
            // child={<WorkflowInfoPrint />}
            title={"اطلاعات گردش کار"}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 9,
      key: "Installment",
      title: "جدول اقساط",
      showDocuments: false,
      showComponent: false,
      justDocuments: false,
      showDocumentsBottomOfPage: true,
      //ToDo-> It was 'props.printedData.scheduleInstallmentData' and didn't work,so it is changed to 'props.printedData.installmentCheques'
      justComponent:
        props.printedData.installmentCheques != null &&
        props.printedData.installmentCheques != undefined &&
        props.printedData.installmentCheques.length > 0 &&
        installmentCheques > 0
          ? false
          : true,
      showItemInModal:
        installmentCheck != undefined && installmentCheck != null
          ? // &&
            // props.printedData.installmentCheques.length > 0
            true
          : false,
      documents:
        props.printedData.installmentCheques != null &&
        props.printedData.installmentCheques != undefined &&
        props.printedData.installmentCheques.length > 0 ? (
          <div className='image-container'>
            <DivisionCmp
              chequeImage={true}
              title={" تصاویر چک "}
              child={
                <Grid
                  container
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                >
                  {props.printedData.installmentCheques?.map(
                    (item: any, index: any) => (
                      <Grid item xs={12} className='classCenter'>
                        <ImagePreviewComponent
                          breakPage={index == 0 ? false : true}
                          file={item.file}
                          rearFile={item.rearFile}
                        />
                      </Grid>
                    )
                  )}
                </Grid>
              }
            ></DivisionCmp>
          </div>
        ) : (
          <></>
        ),
      child:
        installmentCheck != undefined && installmentCheck != null ? (
          <DivisionCmp
            child={<InstallmentCheck data={installmentCheck} />}
            title={installmentCheck[0]?.cheque ? "چک های اقساط" : "اقساط"}
          />
        ) : (
          <></>
        ),
    },

    {
      id: 10,
      key: "LoanCancellationBySupplier",
      title: " علل لغو درخواست",
      showItemInModal: props.printedData.supplierCancellationReasons
        ? true
        : false,
      child:
        props.printedData.supplierCancellationReasons != undefined &&
        props.printedData.supplierCancellationReasons != null ? (
          <DivisionCmp
            child={
              <CancellationReasons
                data={props.printedData.supplierCancellationReasons}
              />
            }
            title={"علل لغو درخواست"}
          />
        ) : (
          <></>
        ),
    },

    {
      id: 11,
      key: "vehicle",
      title: "مدارک خودرو",
      showItemInModal: props.printedData.vehicle ? true : false,
      showComponent: false,
      showDocuments: false,
      justDocuments: false,
      justComponent: false,
      showDocumentsBottomOfPage: false,
      documents:
        props.printedData.vehicle != null &&
        props.printedData.vehicle != undefined &&
        props.printedData.vehicle.documents != undefined &&
        props.printedData.vehicle.documents != null ? (
          <DivisionCmp
            title={" تصاویر مدارک خودرو "}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.vehicle.documents?.map((item: any) =>
                  item.fileType === "Image" || item.fileType === "Any" ? (
                    <Grid
                      item
                      xs={12}
                      className='classCenter'
                      style={{ paddingTop: "2vh" }}
                    >
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                          }}
                          src={item.fileUrl}
                          alt=''
                        />
                      </div>
                    </Grid>
                  ) : (
                    <PdfComponent fileDocument={item.fileUrl} />
                  )
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.vehicle != undefined &&
        props.printedData.vehicle != null ? (
          <DivisionCmp
            child={
              <div style={{ paddingTop: "15px" }}>
                <VehicleDocuments
                  data={props.printedData.vehicle}
                  showDocuments={false}
                />
              </div>
            }
            title={"مدارک خودرو"}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 12,
      key: "vehicleExpert",
      title: "کارشناسی خودرو",
      showItemInModal: props.printedData.vehicleExpert ? true : false,

      showComponent: false,
      showDocuments: false,
      justDocuments: false,
      justComponent: false,
      showDocumentsBottomOfPage: false,
      documents:
        props.printedData.vehicleExpert != null &&
        props.printedData.vehicleExpert != undefined &&
        props.printedData.vehicleExpert.documents != undefined &&
        props.printedData.vehicleExpert.documents != null ? (
          <DivisionCmp
            title={" تصاویر مدارک کارشناسی خودرو "}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.vehicleExpert.documents?.map((item: any) =>
                  item.fileType === "Image" || item.fileType === "Any" ? (
                    <Grid
                      item
                      xs={12}
                      className='classCenter'
                      style={{ paddingTop: "2vh" }}
                    >
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                          }}
                          src={item.fileUrl}
                          alt=''
                        />
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className='classCenter'>
                      <PdfComponent fileDocument={item.fileUrl} />
                    </Grid>
                  )
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.vehicleExpert != undefined &&
        props.printedData.vehicleExpert != null ? (
          <DivisionCmp
            child={
              <div style={{ paddingTop: "15px" }}>
                <VehicleExpert data={props.printedData.vehicleExpert} />
              </div>
            }
            title={"کارشناسی خودرو"}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 13,
      key: "seller",
      title: " مدارک فروشنده",
      showItemInModal: props.printedData.seller ? true : false,
      showComponent: false,
      showDocuments: false,
      justDocuments: false,
      justComponent: false,
      showDocumentsBottomOfPage: false,
      documents:
        props.printedData.seller != null &&
        props.printedData.seller != undefined &&
        props.printedData.seller.identityDocuments != undefined &&
        props.printedData.seller.identityDocuments != null ? (
          <DivisionCmp
            title={" تصاویر مدارک فروشنده"}
            child={
              <Grid
                container
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
              >
                {props.printedData.seller.identityDocuments?.map((item: any) =>
                  item.fileType === "Image" || item.fileType === "Any" ? (
                    <Grid
                      item
                      xs={12}
                      className='classCenter'
                      style={{ paddingTop: "2vh" }}
                    >
                      <div
                        style={{
                          width: "auto",
                          height: "auto",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                          }}
                          src={item.fileUrl}
                          alt=''
                        />
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className='classCenter'>
                      <PdfComponent fileDocument={item.fileUrl} />
                    </Grid>
                  )
                )}
              </Grid>
            }
          ></DivisionCmp>
        ) : (
          <></>
        ),
      child:
        props.printedData.seller != undefined &&
        props.printedData.seller != null ? (
          <DivisionCmp
            child={
              <div style={{ paddingTop: "15px" }}>
                <SellerDocument data={props.printedData.seller} />
              </div>
            }
            title={"مدارک فروشنده"}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 14,
      key: "guarantors",
      title: "مدارک ضامن",
      showItemInModal:
        props.printedData.guarantors != null &&
        props.printedData.guarantors != undefined &&
        props.printedData.guarantors.length > 0
          ? true
          : false,
      showComponent: false,
      showDocuments: false,
      justDocuments: false,
      justComponent: false,
      showDocumentsBottomOfPage: false,
      documents:
        props.printedData.guarantors != undefined &&
        props.printedData.guarantors != null ? (
          props.printedData.guarantors?.map((item: any) => (
            <>
              <DivisionCmp
                title={" تصاویر هویتی ضامن" + " " + item.fullName}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    {item.identityDocuments?.map((item: any) =>
                      item.fileType === "Image" || item.fileType === "Any" ? (
                        <Grid
                          item
                          xs={12}
                          className='classCenter'
                          style={{ paddingTop: "2vh" }}
                        >
                          <div
                            style={{
                              width: "auto",
                              height: "auto",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                overflow: "hidden",
                              }}
                              src={item.fileUrl}
                              alt=''
                            />
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={12} className='classCenter'>
                          <PdfComponent fileDocument={item.fileUrl} />
                        </Grid>
                      )
                    )}
                  </Grid>
                }
              ></DivisionCmp>
              <DivisionCmp
                title={" تصاویر چک ضامن" + " " + item.fullName}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    <Grid item xs={12} className='classCenter'>
                      <ImagePreviewComponent
                        breakPage={false}
                        file={item?.chequeInfo?.file}
                        rearFile={item?.chequeInfo?.rearFile}
                      />
                    </Grid>
                  </Grid>
                }
              ></DivisionCmp>
              <DivisionCmp
                title={" تصاویر درآمدی ضامن" + " " + item.fullName}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    {item.incomeDocuments?.map((item: any) =>
                      item.fileType === "Image" || item.fileType === "Any" ? (
                        <Grid
                          item
                          xs={12}
                          className='classCenter'
                          style={{ paddingTop: "2vh" }}
                        >
                          <div
                            style={{
                              width: "auto",
                              height: "auto",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                overflow: "hidden",
                              }}
                              src={item.fileUrl}
                              alt=''
                            />
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={12} className='classCenter'>
                          <PdfComponent fileDocument={item.fileUrl} />
                        </Grid>
                      )
                    )}
                  </Grid>
                }
              ></DivisionCmp>
              <DivisionCmp
                title={" تصاویر سکونتی ضامن " + " " + item.fullName}
                child={
                  <Grid
                    container
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    style={{ paddingLeft: "2vh", paddingRight: "2vh" }}
                  >
                    {item.residenceDocuments?.map((item: any) =>
                      item.fileType === "Image" || item.fileType === "Any" ? (
                        <Grid
                          item
                          xs={12}
                          className='classCenter'
                          style={{ paddingTop: "2vh" }}
                        >
                          <div
                            style={{
                              width: "auto",
                              height: "auto",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <img
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                overflow: "hidden",
                              }}
                              src={item.fileUrl}
                              alt=''
                            />
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={12} className='classCenter'>
                          <PdfComponent fileDocument={item.fileUrl} />
                        </Grid>
                      )
                    )}
                  </Grid>
                }
              ></DivisionCmp>
            </>
          ))
        ) : (
          <></>
        ),

      child:
        props.printedData.guarantors != undefined &&
        props.printedData.guarantors != null ? (
          <DivisionCmp
            child={
              <div style={{ paddingTop: "15px" }}>
                {props.printedData.guarantors?.map((item: any) => (
                  <>
                    <SellerDocument data={item} />
                    <GuarantorPlaceInfo
                      data={item.residenceDocuments}
                      title={"اطلاعات سکونتی"}
                      postalCode={item.postalCode}
                    />
                    <IncomeInfo data={item.incomeDocuments} />
                    <GuarantorInfo data={item.chequeInfo} />
                  </>
                ))}
              </div>
            }
            title={"مدارک ضامن"}
          />
        ) : (
          <></>
        ),
    },
  ];
  //***services detail */
  const getCoreInformationMutation = useMutation(GetCoreInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        props.setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getAppInformationMutation = useMutation(GetAppInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        props.setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getCartableActionsMutation = useMutation(GetCartableActions, {
    onSuccess: (data: GetCartableActionsResponse[]) => {
      if (data) {
        props.setDataGetCartableActions(data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const { mutate: GetSupplierInformationMutate } = useMutation(
    GetSupplierInformation,
    {
      onSuccess: (data: GetSupplierInformationResponse) => {
        if (data) {
          props.setDataGetCoreInformation(data);
        }
      },
      onError: () => {},
    }
  );
  //***services detail */

  const supplierId = localStorage.getItem("SUPPLIER_ID");

  const refreshBtn = () => {
    if (
      props.getCartableAction == "SupplierSettlementCartable" ||
      props.getCartableAction == "SupplierSearch" ||
      props.getCartableAction == "LoanRegistrationBySupplier"
    ) {
      getCoreInformationMutation.mutateAsync({
        referenceKey: props.referenceKey,
      });
    } else if (
      props.getCartableAction == "CustomerRegistration" ||
      props.getCartableAction == "CustomerSearch"
    ) {
      getAppInformationMutation.mutateAsync({
        referenceKey: props.referenceKey,
      });
    } else if (props.getCartableAction === "SupplierRequirements") {
      GetSupplierInformationMutate({
        supplierId: Number(supplierId),
      });
    }
    if (props.findDetail) {
      getCartableActionsMutation.mutateAsync({
        workflowType: props.getCartableAction!,
        referenceKey: props.referenceKey ?? "",
      });
    }
  };
  const actionHandle = (button: any) => {
    props.setActionTabData(button);
    props.setFlagActionTab(true);
    // GetSupplierInformationMutate({
    //   supplierId: Number(supplierId),
    // });
    // GetSupplierInformation({
    //   supplierId: Number(supplierId),
    // });
  };
  const queryClient = useQueryClient();
  const request = new GetInstallmentTableRequest();
  const ExportInstallmentChequesMutation = useMutation(
    exportInstallmentCheques,
    {}
  );
  const { mutateAsync: getExportInstallmentChequeMutation } = useMutation(
    exportInstallmentCheques,
    {}
  );

  let exportExcel = () => {
    props.isCore
      ? (request.coreReferenceKey = props.requestDetail?.referenceKey)
      : (request.appReferenceKey = props.requestDetail?.referenceKey);
    request.loanRequestId = props.requestDetail?.loanRequestId;
    ExportInstallmentChequesMutation.mutate(request);
  };
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const openModalPrint = () => {
    props.isCore
      ? (request.coreReferenceKey = props.requestDetail?.referenceKey)
      : (request.appReferenceKey = props.requestDetail?.referenceKey);
    request.loanRequestId = props.requestDetail?.loanRequestId;
    // getInstallmentTableMutation(request);
  };

  // const { mutateAsync: getInstallmentTableMutation } = useMutation(
  //   getInstallmentTable,
  //   {
  //     onSuccess: (data: ApiResultModel<GetInstallmentTableResponse[]>) => {
  //       if (data.isSuccess) {
  //         setInstallmentCheck(data.data);
  //         setOpenValidationModel(true);
  //       } else {
  //         toast.error(
  //           <>
  //             <b style={{ color: "red" }}>مشکل در دریافت اطلاعات از سرور</b>
  //             <br />
  //           </>
  //         );
  //       }
  //     },
  //   }
  // );
  const componentToPrint = useRef<HTMLDivElement>(null);
  const history = useHistory<{
    id: any;
    from?: string;
    pageNumber: number;
    clickOnBack: boolean;
    activeCancleButton: boolean;
  }>();

  const handleReturn = () => {
    if (history.length > 2) {
      history.goBack();
    } else {
      window.close();
    }
  };

  const activeCancleButton = history?.location?.state?.activeCancleButton
    ? history?.location?.state?.activeCancleButton
    : JSON.parse(localStorage.getItem("activeCancleButton")!)
        ?.activeCancleButton;

  return (
    <Box
      sx={{
        marginRight: "1.9vh",
        marginLeft: "1.9vh",
        direction: "rtl",
        overflowX: "none",
      }}
    >
      <Grid container justifyContent={"space-between"} alignItems={"center"}>
        <Grid
          item
          xs={4}
          className='centerVertical'
          style={{ margin: "1vh 0" }}
        >
          {/* disable print button, enable if is need */}
          {/* {props.printedData ? (
            <Tooltip title="پرونده" arrow>
              <FolderOpenIcon
                // onClick={() => window.print()}
                onClick={openModalPrint}
                className="colorTitle iconStyle cursorPointer"
              />
            </Tooltip>
          ) : null} */}

          {props.showInstallmentComponent ? (
            <>
              <span
                style={{
                  marginRight: "2vh",
                  marginLeft: "2vh",
                  color: "#CFD8DC",
                }}
              >
                |
              </span>
              <Tooltip title='خروجی اکسل' arrow>
                <img
                  onClick={exportExcel}
                  className='cursorPointer'
                  style={{
                    width: "24px",
                    height: "24px",
                    marginBottom: ".5vh",
                  }}
                  src='images/ExportXLS.svg'
                  alt=''
                />
              </Tooltip>
            </>
          ) : (
            ""
          )}
          <>
            {" "}
            {/* {props.printedData ? (
              <span
                style={{
                  marginRight: "2vh",
                  marginLeft: "2vh",
                  color: "#CFD8DC",
                }}
              >
                |
              </span>
            ) : null} */}
            <Tooltip title='بروزرسانی' arrow>
              <RefreshIcon
                onClick={refreshBtn}
                className='colorTitle iconStyle cursorPointer'
              />
            </Tooltip>{" "}
          </>
        </Grid>

        <Grid item xs={8}>
          <Grid
            container
            gap={{ sx: "unset", sm: "20px" }}
            sx={{ alignItems: "center", width: "100%" }}
            justifyContent={"end"}
            alignItems={"center"}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            {showActionBtns && (
              <Grid item className='actionButtonHeader'>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  {props.dataGetCartableActions?.map((button: any) => (
                    <div
                      className={`${
                        button.workflowStepType === "Forward"
                          ? "Success"
                          : "DangerDefaultFont"
                      } p-4 cursorPointer ${
                        props.flagActionTabs
                          ? "disableForm SecondaryDisableFont"
                          : ""
                      }`}
                    >
                      {!props.showInstallmentComponent && (
                        <Typography
                          className={
                            isActionModalBtnDisable
                              ? "SecondaryDisableFont"
                              : ""
                          }
                        >
                          {button.showAsModal ? (
                            <ActionModal
                              title={button.action}
                              description={button.description}
                              buttonData={button}
                              icon={
                                button.workflowStepType.toLowerCase() ===
                                "forward" ? (
                                  <CheckIcon />
                                ) : (
                                  <RestartAltIcon />
                                )
                              }
                              referenceKey={props.referenceKey}
                              setDataGetCoreInformation={
                                props.setDataGetCoreInformation
                              }
                              setDataGetCartableActions={
                                props.setDataGetCartableActions
                              }
                              getCartableAction={props.getCartableAction}
                              setReload={props.setReload}
                              setShowActionBtns={setShowActionBtns}
                              setActionModalBtnDisable={
                                setActionModalBtnDisable
                              }
                            />
                          ) : (
                            <span onClick={() => actionHandle(button)}>
                              {button.action}
                            </span>
                          )}
                          {button.workflowStepType.toLowerCase() ===
                            "backward" && !button.showAsModal ? (
                            <RestartAltIcon />
                          ) : button.workflowStepType.toLowerCase() ===
                              "forward" && !button.showAsModal ? (
                            <CheckIcon />
                          ) : null}
                        </Typography>
                      )}
                    </div>
                  ))}
                </Box>
              </Grid>
            )}
            {props?.requestDetail?.canBeCancelled && activeCancleButton ? (
              <Grid item sx={{ display: "flex", justifyContent: "end" }}>
                <Button
                  sx={{
                    color: "#E6123D",
                    fontSize: "1rem",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                  }}
                  onClick={() => props.setOpenCancleModal(true)}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                  <span>لغو تسـهیلات</span>
                </Button>
              </Grid>
            ) : null}
            {props.pathname && (
              <Grid item>
                <>
                  <span
                    style={{
                      color: "#1D4A87",
                      float: "left",
                      marginLeft: "10px",
                      margin: "1vh 0px",
                      cursor: "pointer",
                    }}
                    className='cursorPointer'
                    onClick={handleReturn}
                  >
                    بازگشت
                    <ArrowBackIosIcon style={{ width: "12px" }} />
                  </span>
                </>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <ModalPrint
        openModel={openValidationModel}
        setOpenValidationModel={setOpenValidationModel}
        printedData={printedArray}
        id={props.referenceKey}
      />
      {/* </div> */}
    </Box>
  );
}
